<template>
  <div class="content" v-loading="loading">
    <div :class="style">
      <div class="zcdg" v-if="resData.style == '1'">
        <h2 v-text="resData.name"></h2>
        <div class="download-btn-box" v-show="isShow">
          <template v-if="isLogin">
            <a :download="downloadUrl" :href="downloadUrl" @click="saveDownload()" class="download-btn">下载</a>
          </template>
          <template v-else>
            <a href="javascript:void(0)" class="download-btn not-allowed">下载</a>
          </template>
        </div>
        <div class="datasize">本资源大小：{{resData.dataSize}}</div>
        <div class="pdf">
          <iframe ref="mainiframe" :src="baseUrl + resData.dataUrl"></iframe>
        </div>
      </div>
      <div class="biserial" v-if="resData.style == '2'">
        <div class="preview">
          <img v-if="resData.picUrl" :src="picUrl" alt="">
          <video v-if="resData.videoUrl" :src="videoUrl" controls></video>
        </div>
        <div class="biserial-right">
          <h2 v-text="resData.name"></h2>
          <div class="content-detail" v-html="resData.content"></div>
          <div class="datasize">本资源包大小：{{resData.dataSize}}</div>
          <div class="download-btn-box" v-show="isShow">
            <template v-if="isLogin">
              <a :download="downloadUrl" :href="downloadUrl" @click="saveDownload()" class="download-btn">下载</a>
            </template>
            <template v-else>
              <a href="javascript:void(0)" class="download-btn not-allowed">下载</a>
              <p v-show="!this.$store.state.isLogin">下载资源请先登录</p>
            </template>
          </div>
        </div>
      </div>
      <div class="jhcx" v-if="resData.style == '3'">
        <h2 v-text="resData.name"></h2>
        <img :src="picUrl" :alt="resData.name">
      </div>
      <div class="xzsq" v-if="resData.style == '4'">
        <div class="biserial">
          <div class="biserial-right">
            <h2 v-text="resData.name"></h2>
            <div class="content-detail" v-html="resData.content"></div>
            <div class="download-btn-box" v-show="isShow">
              <template v-if="isLogin">
                <a :download="downloadUrl" :href="downloadUrl" @click="saveDownload()" id="list-download-btn01" class="download-btn">列表与说明文件下载</a>
                <a href="javascript:void(0)" @click="applyFn(resData.id)" class="download-btn">下载申请</a>
              </template>
              <template v-else>
                <a href="javascript:void(0)" class="download-btn not-allowed" id="list-download-btn02">列表与说明文件下载</a>
                <a href="javascript:void(0)" class="download-btn not-allowed">下载申请</a>
              </template>
            </div>
          </div>
          <div class="preview-img-list">
              <div>
                <img :src="baseUrl + '/upload/zpxz_img/3.jpg'" alt="">
              </div>
              <div>
                <img :src="baseUrl + '/upload/zpxz_img/4.jpg'" alt="">
              </div>
              <div>
                <img :src="baseUrl + '/upload/zpxz_img/5.jpg'" alt="">
              </div>
          </div>
        </div>
      </div>
      <div class="shangxia" v-if="resData.style == '5'">
        <div class="biserial">
          <div class="biserial-right">
            <h2 v-text="resData.name"></h2>
            <div class="content-detail" v-html="resData.content"></div>
            <div class="download-btn-box" v-show="isShow">
              <template v-if="isLogin">
                <a :download="downloadUrl" :href="downloadUrl" @click="saveDownload()" class="download-btn">下载</a>
              </template>
              <template v-else>
                <a href="javascript:void(0)" class="download-btn not-allowed">下载</a>
              </template>
            </div>
          </div>
          <div class="preview">
            <img v-if="resData.picUrl" :src="picUrl" alt="">
            <video v-if="resData.videoUrl" :src="videoUrl" controls></video>
          </div>
        </div>
      </div>
      <div class="biserial" v-if="resData.style == '8'">
        <div class="biserial-right">
          <h2 v-text="resData.name"></h2>
          <div class="content-detail" v-html="resData.content"></div>
          <div class="datasize">本资源包大小：{{resData.dataSize}}</div>
          <div class="download-btn-box" v-show="isShow">
            <template v-if="isLogin">
              <a :download="downloadUrl" :href="downloadUrl" @click="saveDownload()" class="download-btn">下载</a>
            </template>
            <template v-else>
              <a href="javascript:void(0)" class="download-btn not-allowed">下载</a>
              <p v-show="!this.$store.state.isLogin">下载资源请先登录</p>
            </template>
          </div>
        </div>
      </div>
      <div class="xzsq" v-if="resData.style == '9'">
        <div class="biserial">
          <div class="biserial-right">
            <h2 v-text="resData.name"></h2>
            <div class="content-detail">资源大小：{{resData.dataSize}}</div>
              <div class="download-btn-box" v-show="isShow">
              <template v-if="isLogin">
                <a :download="downloadUrl" :href="downloadUrl" @click="saveDownload()" class="download-btn">下载</a>
              </template>
              <template v-else>
                <a href="javascript:void(0)" class="download-btn not-allowed">下载</a>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog customClass="login-form" title="下载申请" :visible.sync="dialogApplyVisible" :append-to-body="true" width="500px" :center="true" :before-close="handleApplyClose">
      <el-form :model="applyForm" label-width="0px" :rules="applyFormRules" ref="applyForm">
        <el-form-item label="" prop="contactWay">
          <el-input type="textarea" :rows="5" v-model="applyForm.contactWay" placeholder="请输入联系方式" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitApplyForm('applyForm')">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDatabankDetail } from '@/api/databank'
import { saveDownloadLog, downloadApply, downloadGet } from '@/api/download'

export default {
  name: 'Centiare',
  data() {
    return {
      baseUrl: 'http://219.142.112.176/download',
      loading: true,
      downloadUrl: '',
      picUrl: '',
      videoUrl: '',
      isShow: false,
      resData: {},
      dataType: '',
      style: '',
      isLogin: false,
      contentID: 0,
      dialogApplyVisible: false,
      applyFormRules: {
        contactWay: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
      },
      applyForm: {
        dataBankId: 0,
        contactWay: '',
        statusDictId: 6
      },
    }
  },
  watch: {
    $route(){
      this.contentID = this.$route.query.contentID
      this.getDatail()
    },
    '$store.state.isLogin'(newVal,oldVal){
      // 监测登录状态
      this.isLogin = newVal
    }
  },
  created () {
    if(window.localStorage.getItem('isLogin')){
      this.isLogin = window.localStorage.getItem('isLogin')
    }
  },
  mounted() {
    this.getDatail()
  },
  methods: {
    getDatail(){
      getDatabankDetail({
        id: this.$route.query.contentID
      }).then(res => {
        if(res.data.data){
          this.resData = res.data.data
          var dataUrl = res.data.data.dataUrl
          var picUrl = res.data.data.picUrl
          var videoUrl = res.data.data.videoUrl
          this.style = 'style' + res.data.data.style
          
          // 资源路径
          this.downloadUrl = this.baseUrl + dataUrl
          this.picUrl = this.baseUrl + picUrl
          this.videoUrl = this.baseUrl + videoUrl

          this.loading = false
          this.isShow = true
        }
      })
    },
    saveDownload() {
      // 保存下载记录
      saveDownloadLog({
        dataBankId: this.resData.id,
        type: this.resData.type,
        category: this.resData.category,
        name: this.resData.name
      }).then(res => {
        // console.log(res)
      })
    },
    applyFn(id){
      this.applyForm.dataBankId = id
      this.dialogApplyVisible = true
    },
    // 下载申请提交
    submitApplyForm() {
      downloadApply(
        this.applyForm
      ).then(res => {
        if(res.data.code == 200){
          this.$message({
            message: '提交成功',
            type: 'success'
          })
          this.dialogApplyVisible = false
          this.$refs['applyForm'].resetFields()
        }
      })
    },
    // 关闭申请框
    handleApplyClose(done) {
      this.$refs['applyForm'].resetFields()
      this.dialogApplyVisible = false
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  width: 90%;
  margin: 0 auto;
  padding: 100px 0 150px;
}
.content h2 {
  font-size: 30px;
  text-align: center;
  color: #c01509;
}
.style1 .download-btn {
  float: right;
}
.download-btn-box {
  overflow: hidden;
}
.download-btn {
  width: 1.5625rem;
  height: 0.416667rem;
  line-height: 0.416667rem;
  background-color: #c01509;
  text-align: center;
  display: block;
  font-size: 0.177083rem;
  font-weight: bold;
  color: #ffee9c;
  border-radius: 0.052083rem;
}
.download-btn.not-allowed {
  cursor: not-allowed;
  background-color: #999;
  color: #fff;
}
.style1 .content-detail a {
  color: orange!important;
}
.style1 .content-detail a span {
  color: orange!important;
}
.style1 .pdf {
  width: 100%;
  height: 800px;
  padding-top: 50px;
}
.style1 .pdf iframe {
  width: 100%;
  height: 800px;
}
.style1 .datasize {
  font-size: 0.15625rem;
  padding-top: 0.364583rem;
  padding-bottom: 0.15625rem;
  text-align: right;
}

/* 影片下载 */
.style2 .biserial {
  display: flex;
  justify-content: space-between;
}
.style2 .biserial .preview {
  width: 3.90625rem;
  overflow: hidden;
}
.style2 .biserial h2 {
  text-align: left;
}
.style2 .biserial .preview img,.biserial .preview video {
  width: 100%;
}
.style2 .content-detail {
  color: #666;
  font-size: 0.15625rem;
  line-height: 0.3rem;
  padding-top: 0.260417rem;
}
.style2 .datasize {
  font-size: 0.15625rem;
  padding-top: 0.364583rem;
  padding-bottom: 0.15625rem;
}
.style2 .biserial-right {
  width: 4.427083rem;
}
.style2 .download-btn-box {
  display: flex;
  align-items: center;
}
.style2 .download-btn-box p {
  color: #999;
  font-size: 0.145833rem;
  padding-left: 0.104167rem;
}

/* 二维码 */
.style3 .jhcx {
  width: 700px;
  margin: 0 auto;
  display: block;
}
.style3 .jhcx img {
  width: 100%;
  margin-top: 50px;
}

/* 下载申请 */
.xzsq .biserial {
  overflow: hidden;
}
.style4 .biserial .preview {
  width: 100%;
  overflow: hidden;
}
.style4 .biserial h2 {
  text-align: left;
  padding-top: 0.260417rem;
}
.style4 .biserial .preview img {
  width: 100%;
}
.preview-img-list {
  display: flex;
}
.preview-img-list div {
  width: 33%;
  margin: 2px;
}
.preview-img-list div img {
  width: 100%;
}
.style4 .content-detail {
  color: #666;
  font-size: 0.15625rem;
  line-height: 0.3rem;
  padding-top: 0.260417rem;
  padding-bottom: 0.15625rem;
}
.style4 .datasize {
  font-size: 0.15625rem;
  padding-top: 0.364583rem;
  padding-bottom: 0.15625rem;
}
.style4 .biserial-right {
  width: 100%;
  padding-bottom: 0.260417rem;
}
.style4 .download-btn-box {
  display: flex;
  align-items: center;
}
.style4 .download-btn-box p {
  color: #999;
  font-size: 0.145833rem;
  padding-left: 0.104167rem;
}

/* 上下样式5 */
.xzsq .biserial {
  overflow: hidden;
}
.style5 .biserial .preview {
  width: 100%;
  overflow: hidden;
}
.style5 .biserial h2 {
  text-align: left;
  padding-top: 0.260417rem;
}
.style5 .biserial .preview img {
  width: 100%;
}
.style5 .content-detail {
  color: #666;
  font-size: 0.15625rem;
  line-height: 0.3rem;
  padding-top: 0.260417rem;
  padding-bottom: 0.15625rem;
}
.style5 .datasize {
  font-size: 0.15625rem;
  padding-top: 0.364583rem;
  padding-bottom: 0.15625rem;
}
.style5 .biserial-right {
  width: 100%;
  padding-bottom: 0.260417rem;
}
.style5 .download-btn-box {
  display: flex;
  align-items: center;
}
.style5 .download-btn-box p {
  color: #999;
  font-size: 0.145833rem;
  padding-left: 0.104167rem;
}
/* 无图有介绍 */
.style8 .biserial {
  display: flex;
  justify-content: space-between;
}
.style8 .biserial h2 {
  text-align: left;
}
.style8 .content-detail {
  color: #666;
  font-size: 0.15625rem;
  line-height: 0.3rem;
  padding-top: 0.260417rem;
}
.style8 .datasize {
  font-size: 0.15625rem;
  padding-top: 0.364583rem;
  padding-bottom: 0.15625rem;
}
.style8 .download-btn-box {
  display: flex;
  align-items: center;
}
.style8 .download-btn-box p {
  color: #999;
  font-size: 0.145833rem;
  padding-left: 0.104167rem;
}

/* 无图无介绍 */
.style9 .biserial .preview {
  width: 100%;
  overflow: hidden;
}
.style9 .biserial h2 {
  text-align: left;
  padding-top: 0.260417rem;
}
.style9 .biserial .preview img {
  width: 100%;
}
.style9 .content-detail {
  color: #666;
  font-size: 0.15625rem;
  line-height: 0.3rem;
  padding-top: 0.260417rem;
  padding-bottom: 0.15625rem;
}
.style9 .datasize {
  font-size: 0.15625rem;
  padding-top: 0.364583rem;
  padding-bottom: 0.15625rem;
}
.style9 .biserial-right {
  width: 100%;
  padding-bottom: 0.260417rem;
}
.style9 .download-btn-box {
  display: flex;
  align-items: center;
}
.style9 .download-btn-box p {
  color: #999;
  font-size: 0.145833rem;
  padding-left: 0.104167rem;
}
#list-download-btn01,#list-download-btn02 {
  width: 2rem;
  margin-right: 0.3rem;
}
</style>
